/**
 * ProtectedRoute - Componente para proteger rutas que requieren autenticación
 * Redirige a /explorar si el usuario no está autenticado
 */

import React, { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useFirebase } from "../context/ApiContext";
import { BasicModal } from "./BasicModal/BasicModal";
import Auth from "./Auth/Auth";

const ProtectedRoute = ({
	children,
	requireSubscription = false,
	redirectTo = "/",
}) => {
	const { user, initialLoading, subscription } = useFirebase();
	const location = useLocation();
	const [showLogin, setShowLogin] = useState(false);

	// Mientras carga, no mostrar nada (el splash screen se encarga)
	if (initialLoading) {
		return null;
	}

	// Si no hay usuario, mostrar modal de login o redirigir
	if (!user) {
		// Guardamos la ubicación actual para redirigir después del login
		return (
			<Navigate
				to={redirectTo}
				state={{ from: location, showLogin: true }}
				replace
			/>
		);
	}

	// Si se requiere suscripción y no la tiene
	if (requireSubscription && !subscription?.isComplete) {
		return <Navigate to="/pricing" replace />;
	}

	return (
		<>
			{children}
			<BasicModal
				width={500}
				showModal={showLogin}
				handleClose={() => setShowLogin(false)}
			>
				<Auth setShowLogin={setShowLogin} initialMode="login" />
			</BasicModal>
		</>
	);
};

export default ProtectedRoute;
